export const displayTorchNotAvailableScreenSelector = ({displayTorchNotAvailableScreen}) => displayTorchNotAvailableScreen